export default __webpack_public_path__ + "static/media/purchaseImage.99286159.svg";